import type { TolgeePlugin } from '@tolgee/react';

export const TolgeeLanguageDetector: TolgeePlugin = (tolgee, tools) => {
  tools.setLanguageDetector({
    getLanguage(props) {
      if (typeof location !== 'object') {
        console.warn('SSR is not supported!');

        return undefined;
      }

      const parts = location.pathname.split('/');
      const language = parts[1]?.toLowerCase() || '';

      if (!props.availableLanguages.includes(language)) {
        console.warn(`Unsupported Language ${language}!`);

        return undefined;
      }

      return language;
    },
  });

  return tolgee;
};
